import { defineAction } from "rd-action-creators";

export const removeCapmaignByIdAction = defineAction<{ campaignId: string; clientId: string }>("REMOVE_CAMPAIGN_BY_ID");
export const selectCampaignAction = defineAction<{ campaignId: string }>("SELECT CAMPAIGN IN CAMPAIGNS LIST");
export const selectPurchasedCampaignNameAction = defineAction<{ campaignName: string }>(
    "SELECT PURCHASED CAMPAIGN NAME IN CAMPAIGNS LIST"
);
export const updateCampaignList = defineAction<{ payload: any }>("UPDATE CAMPAIGN LIST");
